import styled from "styled-components";

export const InvoiceWrapper = styled.div`
   position: relative;
`;

export const InvoiceTop = styled.div`
   position: relative;
   height: 15rem;
   background: #3578e5;
   display: flex;
   align-items: center;
   padding: 0 4rem;
   margin-bottom: 6rem;
`;

export const InvoiceBody = styled.div`
   background: #fff;
   margin-bottom: 6rem;
   padding: 0 4rem;
`;

export const InvoiceTitle = styled.p`
   font-size: 5.5rem;
   color: #3578e5;
   font-weight: bold;
   padding: 2rem 0;
   text-transform: uppercase;
   margin-bottom: 4rem;
`;

export const List = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0;
`;

export const ListItem = styled.li`
   padding: 1.5rem 0;
   color: #666666;
   max-width: 470px;
`;

export const ListItemHeader = styled.li`
   font-weight: bold;
   font-size: 2.5rem;
   color: #444444;
   margin-bottom: 1rem;
`;

export const TableWrapper = styled.div`
   background: #fafafb;
   margin: 4rem 0;
   padding-bottom: 3rem;
   background: #fdfdff;
`;

export const FlexBtw = styled.div`
   poition: relative;
   display: grid;
   gap: 2em;
   grid-template-columns: 60% 40%;
`;

export const ThanksNote = styled.div`
   text-align: center;
   line-height: 1.3;
`;

export const ThanksTitle = styled.p`
   font-size: 3.3rem;
   color: #3578e5;
`;

export const ThanksEnding = styled.p`
   color: #444444;
   font-size: 2.4rem;
`;
export const RCTable = styled.table`
   text-align: left;
   border-collapse: collapse;
   border: none;
   width: 100%;

   & td,
   & th {
      border: none;
      color: #666666;
      font-size: 1.8rem;
      padding: 1.5rem 4rem;

      &.align-right {
         text-align: right;
      }
   }

   & .bold {
      color: #444444;
      font-size: 2.4rem;
      font-weight: bold;
   }

   & .bordered {
      border-bottom: 0.5px solid rgba(151, 157, 172, 0.5);
   }

   & tr:hover {
      background-color: #ddd;
   }

   & th {
      padding: 2.5rem 4rem;
      text-align: left;
      text-transform: uppercase;
      background: #f0f5fe;
      color: #3578e5;
      border: none;
      font-size: 2.4rem;
   }
`;

export const InvoiceFooter = styled.div`
   margin-top: 4rem;
   padding: 4rem;
`;

export const CopyRight = styled.div`
   max-width: 200px;
   color: #1e2833;
   margin-top: 2rem;
   font-size: 1.5rem;
   font-weight: 500;
`;

export const SocialIcons = styled.div`
   display: flex;
   align-itens: center;
   gap: 2rem;
   margin-top: 2rem;
`;

export const InvoiceFooterLinks = styled.div`
   display: flex;
   align-itens: center;
   gap: 2rem;
   margin-top: 2rem;

   & a {
      text-decoration: none;
      color: #1e2833;
      font-size: 1.5rem;
      font-weight: 500;
   }
`;

export const ActiveLink = styled.a`
   color: #3878e5;
`;
